import axios from 'axios';

// Cache do token para não precisar buscar a cada requisição
let accessToken = '';
let tokenExpiration = 0;

/**
 * Obtém um token de acesso do Cognito usando client_credentials
 */
export const getCognitoToken = async (): Promise<string> => {
  // Se já temos um token válido, retorna ele
  if (accessToken && Date.now() < tokenExpiration) {
    console.log('📋 Usando token em cache, válido por mais', Math.round((tokenExpiration - Date.now()) / 1000), 'segundos');
    return accessToken;
  }

  try {
    const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
    const clientSecret = process.env.REACT_APP_COGNITO_CLIENT_SECRET;
    
    console.log('📋 REACT_APP_COGNITO_CLIENT_ID:', clientId);
    
    if (!clientId || !clientSecret) {
      throw new Error('Configurações do Cognito não encontradas. Verifique as variáveis de ambiente.');
    }
    
    // Criando os parâmetros corretos para o corpo da requisição
    const params = new URLSearchParams();
    params.append('grant_type', 'client_credentials');
    params.append('client_id', clientId);
    params.append('client_secret', clientSecret);
    params.append('scope', 'split-payments/merchant.read split-payments/merchant.write split-payments/movement.write split-payments/payment.read split-payments/payment.write split-payments/receiver.read split-payments/receiver.write split-payments/terminal.read split-payments/movement.read split-payments/dashboard.read');
    
    // URL completa do endpoint do Cognito
    const tokenUrl = 'https://split-auth.auth.sa-east-1.amazoncognito.com/oauth2/token';
    
    console.log('📋 Tentando obter token do Cognito...');
    console.log('📋 URL:', tokenUrl);
    console.log('📋 Client ID:', clientId);
    
    const response = await axios.post(
      tokenUrl,
      params,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
    );
    
    if (response.data && response.data.access_token) {
      accessToken = response.data.access_token;
      tokenExpiration = Date.now() + (response.data.expires_in * 1000);
      console.log('📋 Token obtido com sucesso. Expira em', response.data.expires_in, 'segundos');
      
      // Mostrar os primeiros e últimos caracteres do token para fins de depuração
      const firstChars = accessToken.substring(0, 10);
      const lastChars = accessToken.substring(accessToken.length - 10);
      console.log(`📋 Token: ${firstChars}...${lastChars}`);
      
      return accessToken;
    } else {
      console.error('📋 Resposta do Cognito:', response.data);
      throw new Error('Resposta não contém token');
    }
  } catch (error: any) {
    console.error('📋 Erro ao obter token do Cognito:', error.message);
    if (error.response) {
      console.error('📋 Detalhes do erro:', error.response.data);
    }
    throw error;
  }
}; 